function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{opacity:0.8;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "a",
  transform: "translate(0 -6.764)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M3.3,23.028c2.316,0,3.414-1.552,3.414-4.107,0-1.528-.692-3.366-2.865-3.366-.478,0-.979.048-.979-.263,0-.143.143-.191.74-.239,1.6-.095,2.627-1.934,2.627-3.509A2.816,2.816,0,0,0,3.2,8.462c-.955,0-1.266.1-1.266.287V22.765C1.934,22.98,2.293,23.028,3.3,23.028Zm-.549.668c-.477,0-1.934-.024-2.125,0C.215,23.7,0,23.6,0,23.385V8.128c0-.262.5-.286.859-.286.645,0,1.7-.024,3.057.072A4.054,4.054,0,0,1,7.927,11.59c0,1.887-1.242,2.913-2.746,3.605,2.077.5,3.629,1.839,3.629,3.844,0,4.036-3.8,4.656-6.065,4.656",
  transform: "translate(0 -0.777)"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M42.086,7.448c-4.006,0-5.74,3.151-5.74,7.253,0,5.153,3,7.547,5.056,7.547.732,0,.928-.122.928-.415V14.75c0-.244-.2-.317-.2-.44,0-.048.049-.1.245-.1h1.514c.367,0,.586.122.611.464v7.644c0,.416,0,.586-.221.611-.415.048-1.147.074-1.465.074-6.2,0-8.89-4.25-8.89-8.28a7.948,7.948,0,0,1,7.937-7.962c2,0,2.613.464,2.613.782,0,.2-.292.367-.561.367C43.306,7.912,42.941,7.448,42.086,7.448Z",
  transform: "translate(-24.504)"
}));

var SvgBgSignatureBlackRgb = function SvgBgSignatureBlackRgb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 16.242,
      viewBox: "0 0 20 16.242",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgBgSignatureBlackRgb, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/BGSignature_Black_RGB.74c490d9.svg";
export { ForwardRef as ReactComponent };